<template>
  <div>
    <v-autocomplete
      label="Mail Template"
      name="mailtemplate"
      ref="customerSelectbox"
      v-bind="$attrs"
      v-model="selected"
      :search-input.sync="searchCustomers"
      :loading="loading"
      :items="customersList"
      :value="value"
      return-object
    >
      <template v-slot:append-outer>
        <v-chip small dense>
          {{ customersList ? customersList.length : 0 }}
        </v-chip>
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            Template suchen
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import MailTemplateService from "@/services/MailTemplateService";

export default {
  name: "MailTemplateSelectbox",
  props: ["value"],
  data: () => ({
    initial: false,
    selected: null,
    customersList: [],
    foundItems: null,
    loading: false,
    searchCustomers: null
  }),
  computed: {},
  methods: {
    updateValue(value) {
      if (!this.initial) {
        this.selected = value;
        this.$emit("input", this.selected);
      }
    }
  },

  watch: {
    value(val) {
      this.selected = { text: val.name, value: val };
      this.customersList = [{ text: val.name, value: val }];
    },
    selected(value) {
      this.$emit("input", value ? value.value : null);
    },

    searchCustomers(name) {
      /* if (this.loading == true) {
        return;
      }
*/

      if ((name && name.length < 3) || this.initial) {
        return;
      }
      if (name && (!this.selected || this.selected.text !== name)) {
        this.loading = true;
        let foundItems = [];
        MailTemplateService.getAll()
          .then(result => {
            result.data.data.forEach(item => {
              foundItems.push({ text: item.name, value: item._id });
            });
          })
          .catch(error => {
            foundItems = [];
            if (error.response.status != 401) {
              this.$notify({
                group: "dataline",
                type: "error",
                title: "Fehler",
                text: error.message
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.customersList = foundItems;
          });
      }
    }
  },
  created() {}
};
</script>
